import React from 'react';

const Loader = ({ show, size }) => {
    return <div className={`${show ? 'flex' : 'hidden'} ${size ? size : 'w-6 h-6'} rounded-full border-2 border-t-0 border-indigo-100 animate-spin`} />
}

export default Loader;